// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e174df33","453":"51d6632c","455":"60a3e914","977":"7e4eef88"}[chunkId] + ".chunk.js";
};